
import { Component, Inject, Vue } from 'vue-property-decorator';
import GeneralScaffold from '@/components/GeneralScaffold.vue';
import PagedDataTable from '@/components/PagedDataTable.vue';
import CouponRepository from '@/repositories/webshop/CouponRepository';

@Component({
    components: { GeneralScaffold, PagedDataTable },
})
export default class CouponListScreen extends Vue {
    @Inject()
    private readonly couponRepository!: CouponRepository;

    public get headers(): any[] {
        return [
            {
                text: this.$t('general.actions'),
                value: 'action',
                sortable: false,
            },
            {
                text: this.$t('crud.coupon.code'),
                align: 'left',
                value: 'code',
                sortable: true,
            },
            {
                text: this.$t('crud.coupon.type'),
                value: 'typeVerbose',
                sortable: true,
            },
            {
                text: this.$t('crud.coupon.value'),
                value: 'value',
                sortable: true,
            },
            {
                text: this.$t('crud.coupon.label'),
                value: 'label',
                sortable: true,
            },
            {
                text: this.$t('crud.coupon.products'),
                value: 'productIds',
                sortable: true,
            },
            {
                text: this.$t('crud.coupon.maxConsumers'),
                value: 'useCountVerbose',
                sortable: true,
            },
            {
                text: this.$t('crud.coupon.expiry'),
                value: 'expiry',
                sortable: true,
            },
        ];
    }
}
